<template>
  <div id="progress-container" class="bg-white rounded p-4">
    <h4>{{ tutorialInProgressSpiel }}</h4>
    <div id="tutorial-progress">
      <b-progress :value="total_progress" :max="max"></b-progress>
      <div class="progress-label mt-2" v-if="total_progress >= 30">
        {{ `${fomrattedTotalProgress}% complete - ${milestoneSpiels}` }}
      </div>
      <div class="video-list mt-4">
        <div :class="['video-item d-flex align-items-center', {
          'mb-3': index < courses.length - 1
        }]"
          v-for="(vid, index) in courses" :key="`lesson-${index}`"
          @click="handleVideo(index)">
          <div :class="['vid-icon rounded-circle mr-3 d-inline-flex align-items-center justify-content-center position-relative flex-shrink-0', {
            'done': isDone(vid) && !vid.is_playing
          }]">
            <img src="@/assets/images/rush-academy/checkmark.svg" alt="Done video" v-if="isDone(vid) && !vid.is_playing">
            <template v-else>
              <img src="@/assets/images/rush-academy/play-icon.svg" alt="Play video" v-if="!vid.is_playing">
              <template v-else>
                <img src="@/assets/images/rush-academy/pause-icon.svg" alt="Pause video" class="position-absolute">
                <span class="position-absolute vid-playing-progress">
                  <vue-ellipse-progress
                    :progress="calculateVideoProgress(vid)"
                    :legend="false"
                    :size="50" />
                  </span>
              </template>
            </template>
          </div>
          <div :class="['vid-details d-flex flex-grow-1', {
            'in-progress': vid.is_playing
          }]">
            <span class="vid-title flex-grow-1 mr-1">{{ vid.name }}</span>
            <span class="vid-length">{{ transformTimeDisplay(vid.video_length) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/plugins/vue-ellipse-progress.js";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "RushAcademyTutorialProgress",
  props: ["courses", "total_progress"],
  data() {
    return {
      max: 100
    }
  },
  computed: {
    ...mapGetters({
      rush_academy: "rushAcademy/rush_academy",
      errors: "rushAcademy/errors"
    }),
    tutorialInProgressSpiel: {
      get() {
        return Number(this.total_progress) > 0 && Number(this.total_progress) < 100
          ? "Tutorial in progress"
          : Number(this.total_progress) === 100
          ? "Congratulations!"
          : "Your Tutorial Progress";
      },
      set(message) {
        return message;
      }
    },
    fomrattedTotalProgress: {
      get() {
        return Math.floor(this.total_progress);
      },
      set(progress) {
        return progress;
      }
    },
    milestoneSpiels: {
      get() {
        return Number(this.total_progress) >= 30 && Number(this.total_progress) < 60
          ? "Continue learning!"
          : Number(this.total_progress) >= 60 && Number(this.total_progress < 100)
          ? "You're doing great!"
          : Number(this.total_progress) === 100
          ? "Congratulations!"
          : "";
      },
      set(spiel) {
        return spiel;
      }
    }
  },
  methods: {
    transformTimeDisplay(time) {
      const splitParts = time.split(':');
      const isHours = Number(splitParts[0]) > 0;
      const constructTime = { hour: splitParts[0], minute: splitParts[1], second: splitParts[2] };
      return !isHours
        ? this.$moment(constructTime).format("m:ss")
        : this.$moment(constructTime).format("H:mm:ss");
    },
    isDone(video) {
      return video.status === 3;
    },
    calculateVideoProgress(video) {
      const current_time_seconds = this.$moment(video.current_time, 'HH:mm:ss: A').diff(this.$moment().startOf('day'), 'seconds');
      const time_span_seconds = this.$moment(video.video_length, 'HH:mm:ss: A').diff(this.$moment().startOf('day'), 'seconds');
      return video.current_time ? (current_time_seconds / time_span_seconds) * 100 : 0;
    },
    async handleVideo(videoIndex) {
      const video = this.courses[videoIndex]
      const currentVideoId = this.$route.params.video;
      const videoId = video.url.split('/').pop();
      if (currentVideoId === videoId && video.is_playing) this.$root.$emit('pause-video');
      else if (currentVideoId === videoId && !video.is_playing) this.$root.$emit('play-video');
      else {
        await this.$root.$emit('save-video-progress');
        setTimeout(() => {
          if (_.isEmpty(this.errors)) {
            this.$router.push({ path: `/rush-academy/${videoId}` });
            this.$emit('change-video', video);
          }
        }, 300);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@500;700&display=swap');
* {
  font-family: MainFontRegular, sans-serif;
}
h4 {
  font-size: 18px;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
  color: #2F3941;
}
#progress-container {
  box-shadow: 0px 4px 25px rgba(78, 79, 83, 0.04);
}
.progress {
  height: 4px;
  background-color: #E9EBED;
}
.progress-label {
  font-size: 14px;
  color: #49545C;
}
.video-list {
  .video-item {
    cursor: pointer;
    .vid-icon {
      width: 50px;
      height: 50px;
      background-color: rgba(81, 129, 255, 0.1);
      &.done {
        background-color: #31BA70;
      }
      .vid-playing-progress {
        top: 0;
        left: 0;
      }
    }
    .vid-details {
      font-size: 14px;
      color: #87929D;
      .vid-length {
        font-family: MainFontBold, sans-serif;
        font-weight: normal;
      }
      &.in-progress {
        color: #5182FF;
        & > * {
          font-family: MainFontBold, sans-serif;
          font-weight: normal;
        }
      }
    }
  }
}
</style>

<style lang="scss">
#tutorial-progress .progress-bar {
  background-color: #5182FF;
}
</style>